<template>
  <div>
    <div class="page-container">
      <result :state="state" :desc="desc" :title="title" />
    </div>
  </div>
</template>
<script>
import result from "@/components/base/result";
export default {
  name: "BaseNoData",
  components: {
    result,
  },
  data() {
    return {
      state: "error",
      desc: "",
    };
  },
  computed: {},
  created() {
    this.state = "warning";
    this.title =
      "Token过期或者无权限，请重新登录或者联系管理员添加权限后再登录";
  },
  methods: {},
};
</script>
<style lang="less" scoped></style>
